import { Stack } from '@mui/material';
import bg from 'static/imgs/icon_bg.png';

export default function IconBg({ children, size }) {
  return (
    <Stack
      sx={{
        width: size,
        height: size,
        borderRadius: 5,
        background: `url(${bg})`,
        backgroundSize: 'cover',
      }}
      justifyContent="center"
      alignItems="center"
    >

      {children}
    </Stack>
  );
}
